import { render } from "./Co2Info.vue?vue&type=template&id=0d991d73&scoped=true"
import script from "./Co2Info.vue?vue&type=script&lang=js"
export * from "./Co2Info.vue?vue&type=script&lang=js"

import "./Co2Info.vue?vue&type=style&index=0&id=0d991d73&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dxworks\\Downloads\\dpp_adm_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d991d73"]])

export default __exports__